import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import InternetCustomerInfoForm from '../Partials/InternetCustomerInfo/InternetCustomerInfoForm';
import PackageDetails from '../Partials/PackageDetails/PackageDetails';
import { goToPage, setIsSubmit, setPersonalInfo, reportDWH } from '../saleJetBlockSlice';
import { createOtpForNewCustomerAsync } from '../saleBlockAsyncThunk';
import { gtag4 } from '../../../../utilities/analytics/tracking';

const InternetCustomerInfoPage = (props) => {
  useEffect(() => {
    props.reportDWH({ actionType: 'Customer Info', status: 'Ongoing', messageText: 'Internet Customer Info Displayed' });
    gtag4({
      event: `${props.saleType}_Step5_InternetCustomerInfoPage`,
      step: '5',
      action: 'InternetCustomerInfoPage',
      funnel_name: 'Sivim_Exists',
    });
  }, []);

  const title = props.internetCustomerInfoTitle?.trim() || 'מעולה, כמה פרטים ונתקדם';
  const subtitle = props.internetCustomerInfoSubtitle?.trim() || 'אחריהם נמשיך לתיאום התקנה ותשלום';

  const currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title-big'>{title}</h1>
      <h2 className='sale-title-small'>{subtitle}</h2>
    </div>
  );

  return (
    <div className='slideAnimation'>
      <div className='package-details-wrapper package-details-wrapper--step-bar'>
        <PackageDetails />
      </div>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          <InternetCustomerInfoForm
            isSubmit={props.isSubmit}
            onSubmit={handlePageValidate}
            firstName={props.firstName}
            lastName={props.lastName}
            phoneNumber={props.phoneNumber}
          />
        </form>
        <SaleFooter
          isDisplayFooter={true}
          btnText='המשך'
          onclick={handlePageContinue}
          formid='saleJet'
        />
      </div>
    </div>
  );

  function handlePageContinue() {
    props.setIsSubmit(true);
  }

  function handlePageValidate(data) {
    props.setIsSubmit(false);
    if (!data.isValid || props.saleType !== 'internet') {
      return;
    }

    props.setPersonalInfo({
      identity: data.data.identity,
      firstName: data.data.firstName,
      lastName: data.data.lastName,
      subscriberNo: data.data.phoneNumber,
    });
    props.reportDWH({ actionType: 'Customer Info', status: 'Ongoing', messageText: 'Internet Customer Info Button Clicked' });
    gtag4({
      event: `${props.saleType}_Step5_InternetCustomerInfoContinueButton`,
      step: '5',
      button: 'המשך',
      action: 'InternetCustomerInfoContinueButton',
      funnel_name: 'Sivim_Exists',
    });
    props.createOtpForNewCustomerAsync({
      contactNumber: data.data.phoneNumber,
      identity: data.data.identity,
      otpFlow: 'internetCustomerInfo',
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
  }
};

const mapStateToProps = (state) => {
  const { personalInfo, addressPage } = state.saleJetBlock;
  const selectedAddress = addressPage?.selectedAddress ?? {};

  return {
    saleType: state.saleJetBlock.saleType,
    isSubmit: state.saleJetBlock.isSubmit,
    firstName: personalInfo.firstName || selectedAddress.firstName || '',
    lastName: personalInfo.lastName || selectedAddress.lastName || '',
    phoneNumber: personalInfo.subscriberNo || selectedAddress.phoneNumber || '',
    internetCustomerInfoTitle: state.saleJetBlock.saleBlockData.internetCustomerInfoTitle,
    internetCustomerInfoSubtitle: state.saleJetBlock.saleBlockData.internetCustomerInfoSubtitle,
  };
};

const mapDispatchToProps = {
  goToPage,
  setIsSubmit,
  setPersonalInfo,
  reportDWH,
  createOtpForNewCustomerAsync,
};

export default connect(mapStateToProps, mapDispatchToProps)(InternetCustomerInfoPage);
